const initialState = {
  isAuth: false
};

export default initialState;
